import { Ciap, DimensaoProcedimento } from 'graphql/types.generated'
import { isUndefinedOrNull } from 'util/checks'

import { extractFromFiltro } from '../utils-HistoricoDwCiapFiltro'
import { CiapProcedimento } from './HistoricoCiapProcedimento'

export const convertToCiapsProcedimentos = (
  filtro: string | null | undefined,
  ciaps: Ciap[],
  procedimentosSisab?: DimensaoProcedimento[] | null
) =>
  [
    ...extractFromFiltro(filtro).map((codigo) => {
      const ciap = ciaps.find((ciap) => ciap.codigo === codigo)
      if (isUndefinedOrNull(ciap)) return null
      return ciapToCiapProcedimento(ciap)
    }),
    ...(procedimentosSisab || []).map((procedimento) => {
      return procedimentoToCiapProcedimento(procedimento)
    }),
  ]
    .filter((item): item is CiapProcedimento => item !== null)
    ?.toSorted((a, b) => a.descricao.localeCompare(b.descricao))

const ciapToCiapProcedimento = (ciap: Ciap): CiapProcedimento => ({
  codigo: ciap.codigo,
  descricao: ciap.descricao,
  tipo: 'CIAP',
})

const procedimentoToCiapProcedimento = (procedimento: DimensaoProcedimento): CiapProcedimento => ({
  codigo: procedimento.codigoProcedimento,
  descricao: procedimento.descricaoProcedimento,
  tipo: 'SISAB',
})
